import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { EventLoggerService } from '@services/event-logger-service';
import { UnpaidPendingCallService } from '@services/pending-call-banner-service';
import { TimeSlot } from '@shared/bottom-sheet-layouts/pending-call-bottomsheet/request-call-bottomsheet/request-call-bottomsheet.component';
import { ApiClientConstant } from '@cureskin/api-client';
import { Router } from '@angular/router';
import { CsIconModule } from '@components/icon';
import {PRIMARY_CHANNELS} from '@services/event-logger-service/event-logger.constant';
import {AppConfig} from '../../../app.config';

@Component({
  selector: 'app-request-call-banner',
  standalone: true,
  imports: [NgIf, CsIconModule],
  templateUrl: './request-call-banner.component.html',
})
export class RequestCallBannerComponent implements OnInit {
  @Input() experimentVariantData: any;
  @Input() regimen!: { objectId: string };
  @Input() regimenClass: string;
  @Input() supportView: boolean = false;
  @Output() pendingCallCreated: EventEmitter<boolean> = new EventEmitter<boolean>();
  newBannerUI: boolean = false;
  private pageName: string = 'regimen';
  public hours!: number;
  public slot!: TimeSlot;

  constructor(
    private readonly eventLogger: EventLoggerService,
    private readonly pendingCallService: UnpaidPendingCallService,
    private readonly router: Router,
    private readonly appConfig: AppConfig,
  ) {}

  ngOnInit(): void {
    this.newBannerUI = this.experimentVariantData.newBannerUI
    const { hours, slot } = this.pendingCallService.initializeTAT(this.experimentVariantData);
    this.slot = slot;
    this.hours = hours;
    this.pageName = this.router.url === `/${this.appConfig.Shared.PAGES.SUPPORT}` ?
      this.appConfig.Shared.PAGES.SUPPORT : this.appConfig.Shared.TABS.REGIMEN;
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ name: `${this.pageName}_unpaid_user_call_banner_seen` }), PRIMARY_CHANNELS);
  }

  /** Helpers for template */
  get showWorkingHours(): boolean {
    return this.slot === 'working';
  }
  get showTomorrowMorning(): boolean {
    return this.slot === 'evening';
  }
  get showAfterNineAm(): boolean {
    return this.slot === 'early';
  }

  /** Open bottom sheet & handle lifecycle */
  async bannerClick(): Promise<void> {
    this.eventLogger.cleverTapEvent(
      'click',
      JSON.stringify({ name: `${this.pageName}_unpaid_user_call_request_banner` }),
    );

    const success = await this.pendingCallService.openRequestCallBottomsheet(
      this.regimen.objectId,
      this.regimenClass,
      this.hours,
      this.slot
    );

    if (success) this.pendingCallCreated.emit(true);
  }

  protected readonly ApiClientConstant = ApiClientConstant;
}
